import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import GPTAnswer from "../../components/cancerGpt/GPTAnswer";
import GPTMessage from "../../components/cancerGpt/GPTMessage";
import UserMessage from "../../components/cancerGpt/UserMessage";
import Btn from "../../components/common/Btn";
import HeadCont from "../../components/common/HeadCont";

const CancerGPT = () => {
  const { loginInfo } = useSelector((state) => state.commonApp);
  const textArea = useRef(null);
  const contentRef = useRef(null);
  const navigate = useNavigate();

  const [cancerQ, setCancerQ] = useState(null);
  const [questionAsked, setQuestionAsked] = useState({
    message: "",
    state: false,
  });
  const [count, setCount] = useState(null);

  // Scroll to top on mount - fix for physical iPhone devices
  useEffect(() => {
    // Reset scroll position for physical devices
    if (contentRef.current) {
      contentRef.current.scrollTop = 0;
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);

  const onChangeAction = (e) => {
    setCancerQ(e.target.value);
    setCount(e.target.value.length);
    e.target.style.height = "66px";
    let textAreaH = e.target.scrollHeight;
    e.target.style.height = `${textAreaH}px`;
  };

  const onClickButton = () => {
    setQuestionAsked({ message: cancerQ, state: true });
    setCancerQ(null);
    textArea.current.style.height = "66px";
  };

  return (
    <>
      <HeadCont
        leftIcon={"no icon"}
        rightIcon={"close"}
        title={"Ask me anything"}
        onRightAction={() => navigate(-1)}
      />
      <div ref={contentRef} className="w-full flex justify-center overflow-y-auto">
        <section className="w-full max-w-[768px] pb-40 safe-area-mt-header-minimal">
          <GPTMessage page={true} nav={"cancergpt"} />

          {/* Medical Information Disclaimer Box */}
          <div className="mx-6">
            <div className="bg-[#FEF9E7] border-l-4 border-[#F1C40F] rounded-lg p-4">
              <div className="flex items-start gap-2">
                <span className="text-xl mt-0.5">⚠️</span>
                <div className="flex-1">
                  <h3 className="font-bold text-[#856404] text-base mb-2">
                    Medical Information Disclaimer
                  </h3>
                  <div className="text-[#856404] text-sm leading-relaxed space-y-2">
                    <p>
                      This AI chatbot is powered by OpenAI's ChatGPT and provides general health information based on your Healiary data.
                    </p>
                    <p className="font-semibold">
                      Important: This is NOT medical advice. Always consult with qualified healthcare professionals for medical decisions, diagnosis, or treatment.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {questionAsked.state && (
            <UserMessage
              characterPhoto={loginInfo.characterPhoto}
              message={questionAsked.message}
            />
          )}
          {questionAsked.state && (
            <GPTAnswer question={questionAsked.message} cancerQ={cancerQ} />
          )}
        </section>
      </div>

      <div className="fixed bottom-0 left-0 right-0 z-50 flex w-full items-center justify-center border-t border-gray_40 bg-white safe-area-bottom">
        <div className="flex w-full max-w-[768px] flex-col p-4 pb-6">
          <div className="flex items-end justify-start gap-2">
            <textarea
              ref={textArea}
              onChange={(e) => onChangeAction(e)}
              id={"question"}
              name={"question"}
              value={cancerQ === null ? "" : cancerQ}
              maxLength={"60"}
              placeholder={"Please write within 60 characters."}
              className="no-scrollbar h-[66px] w-full resize-none appearance-none rounded border border-gray_80 p-4 text-base text-black placeholder:text-sm placeholder:text-gray_120 focus:border-gray_160 focus:outline-none focus:ring-0"
              style={{ minHeight: '66px', lineHeight: '1.5' }}
            />
            <div className="flex-shrink-0">
              <Btn
                title={"Ask"}
                bgColor={"bg-main"}
                textColor={"text-white"}
                active={!(cancerQ === "") && !(cancerQ === null) ? "on" : "ready"}
                onAction={onClickButton}
                innerClass={"w-full h-[66px]"}
                option="gpt"
              />
            </div>
          </div>
          {cancerQ && (
            <div className="ml-auto pt-1 pr-2">
              <span className="text-xs text-gray_160">{count}/60</span>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CancerGPT;
